import { FC, useRef } from 'react';
import { Notes } from '@mui/icons-material';
import { IconButton, Tooltip, Typography } from '@mui/material';
import {
  chatActions,
  chatSelectors,
  useAppDispatch,
  useAppSelector,
} from '@vs-online-only-app/state';
import { SavedRepliesModal } from './SavedRepliesModal';

const MessageComposerSavedReplies: FC = () => {
  const dispatch = useAppDispatch();
  const isSavedRepliesModalOpen = useAppSelector(
    chatSelectors.selectSavedRepliesModalOpen,
  );
  const savedRepliesButtonRef = useRef<HTMLButtonElement>(null);

  const openSavedRepliesModal = () => {
    if (isSavedRepliesModalOpen) return;
    dispatch(chatActions.setSavedRepliesModalOpen(true));
    dispatch(chatActions.clearSelectedSavedReplyContent());
  };

  return (
    <>
      <Tooltip arrow title={<Typography>Saved replies</Typography>}>
        <IconButton onClick={openSavedRepliesModal} ref={savedRepliesButtonRef}>
          <Notes />
        </IconButton>
      </Tooltip>
      {isSavedRepliesModalOpen && (
        <SavedRepliesModal anchorRef={savedRepliesButtonRef} />
      )}
    </>
  );
};

export default MessageComposerSavedReplies;
